import React from 'react';
import { useTranslation } from 'react-i18next';
import {Routes, Route, Navigate, useParams, Outlet } from "react-router-dom";
import MainPage from "./pages/MainPage";
import FrameService from "./pages/FrameService";
import PolicyPage from 'pages/PolicyPage';
import ProgramsPage from 'pages/ProgramsPage';
import WhoAreWePage from 'pages/WhoAreWePage';
import ScrollToTop from 'components/ScrollToTop/ScrollToTop';
import FaqPage from 'pages/FaqPage';
import PaymentPage from 'pages/PaymentPage';

const LangLayout = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  React.useEffect(() => {
    if (lang === 'en' || lang === 'ru') {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return <Outlet />;
};

const App = () => (
  <>
  <ScrollToTop />
  <Routes>
    <Route path="/" element={<Navigate to="/en" replace />} />

    <Route path="/:lang" element={<LangLayout />}>
      <Route index element={<MainPage />} />
      <Route path="programs" element={<ProgramsPage />} />
      <Route path="who-are-we" element={<WhoAreWePage />} />
      <Route path="terms-and-conditions" element={<PolicyPage />} />
      <Route path="frame-service" element={<FrameService />} />
      <Route path="faq" element={<FaqPage/>} />
      <Route path="payment" element={<PaymentPage/>} />
    </Route>
  </Routes>
  </>
);

export default App;